import React from 'react';
import { styled } from 'styled-components';
import { getMappedMediaQuery } from '../../../../play-core/styles/style-helper';
import { useSectionsConfig } from '../../providers/UiConfigProvider/UiConfigContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const Section = ({
  children,
  needsTopSpacing = false,
  preventBottomSpacing = false,
  ...props
}) => {
  const {
    topSpacing
  } = useSectionsConfig();
  return /*#__PURE__*/_jsx(StyledSection, {
    needsTopSpacing: needsTopSpacing,
    preventBottomSpacing: preventBottomSpacing,
    topSpacing: topSpacing,
    ...props,
    children: children
  });
};
export const sectionSpacing = {
  default: '32px',
  mediaQuery: [['mediumUp', '50px']]
};
const bottomSpacing = getMappedMediaQuery(sectionSpacing, 'padding-bottom');
export const StyledSection = styled.section.withConfig({
  displayName: "Section__StyledSection",
  componentId: "sc-1alt02r-0"
})(["position:relative;", " ", " &:empty{display:none;}"], ({
  needsTopSpacing,
  topSpacing
}) => needsTopSpacing && getMappedMediaQuery(topSpacing || sectionSpacing, 'margin-top'), ({
  preventBottomSpacing
}) => !preventBottomSpacing && bottomSpacing);